import React from 'react'
import Box from '@mui/material/Box'
import { useShowcaseContext } from '../../../app/showcase/contexts/ShowcaseContext'
import MoreFilterButton from './buttons/MoreFilterButton'
import PatternNameSearchFilter from './filters/PatternNameSearchFilter'
import TypeSelect from './type/TypeSelect'
import SortSelect from './sort/SortSelect'
import { useTheme } from '@mui/material/styles'
import { useMediaQuery } from '@mui/material'
import FilterDisplay from './FilterDisplay'

function ShowcaseFilterView({ condensed }: any) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const { backtestFilters, setBacktestFilters, backtestSort, setBacktestSort, type, setType } =
    useShowcaseContext()

  return (
    <Box display={'flex'} width={'100%'} gap={1} flexDirection={'column'}>
      <Box display={'flex'} width={'100%'} gap={1}>
        <Box display="flex" gap={1} alignItems="center">
          <PatternNameSearchFilter
            backtestFilters={backtestFilters}
            setBacktestFilters={setBacktestFilters}
          />
          <TypeSelect type={type} setType={setType} />
          {!isMobile && (
            <SortSelect backtestSort={backtestSort} setBacktestSort={setBacktestSort} />
          )}
        </Box>
        <Box flexGrow={1} display="flex" justifyContent="flex-end" alignItems="center" gap={1}>
          {!isMobile && (
            <FilterDisplay
              backtestFilters={backtestFilters}
              setBacktestFilters={setBacktestFilters}
            />
          )}
          <MoreFilterButton
            backtestFilters={backtestFilters}
            setBacktestFilters={setBacktestFilters}
            backtestSort={backtestSort}
            setBacktestSort={setBacktestSort}
          />
        </Box>
      </Box>
      {isMobile && (
        <FilterDisplay
          backtestFilters={backtestFilters}
          setBacktestFilters={setBacktestFilters}
          showLabel={false}
        />
      )}
    </Box>
  )
}

export default ShowcaseFilterView
